export default {"src":"/_next/static/media/arrow-up-right.ba42a0fb.svg","height":16,"width":16};